import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './ToastMessage.style.css';

const ToastMessage = ({ closeToast, title, message }) => {
  return (
    <>
      <div className="toast-header">
        <strong>{title}</strong>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <small style={{ fontSize: '11px', marginRight: '7px' }}>11 mins ago</small> */}
          <CloseIcon fontSize="small" onClick={closeToast} />
        </div>
      </div>
      <div className="toast-body">
        {message}
      </div>
    </>
  )
}

export default ToastMessage;
